export default [
  {
    path: '/surgery-accounting',
    name: 'surgery-accounting',
    component: () => import('@/views/accounting/surgeryAccounting.vue'),
  },
  {
    path: '/accounting-patient',
    name: 'accounting-patient',
    component: () => import('@/views/accounting/patientInvoices.vue'),
  },
  {
    path: '/accounting-patient-history',
    name: 'accounting-patient-history',
    component: () => import('@/views/accounting/patientInvoicesAll.vue'),
  },
  {
    path: '/patient-invoices-detail/:patientId',
    name: 'patient-invoices-detail',
    component: () => import('@/views/accounting/PatientInvoicesDetail.vue'),
  },
  {
    path: '/acounting-invoices/:patientId/:patientCardId/:isPatientAccounting/:isSurgeryAccounting',
    name: 'acounting-invoices',
    component: () => import('@/views/accounting/Invoices.vue'),
  },
  {
    path: '/patient-stay-invoice/:patientStayId/:patientId',
    name: 'patient-stay-invoice',
    component: () => import('@/views/accounting/PatientStayInvoice.vue'),
  },
  {
    path: '/doctor-accounting',
    name: 'doctor-accounting',
    component: () => import('@/views/accounting/DoctorAcounting.vue'),
  },
  {
    path: '/invoice-insurance-surgery/:name/:id',
    name: 'invoice-insurance-surgery',
    component: () => import('@/views/accounting/InvoiceInsuranceSurgery.vue'),
  },
  {
    path: '/SurgeryPatientHistoryAccounting',
    name: 'surgery-patient-history-accounting',
    component: () => import('@/views/accounting/SurgeryPatientHistoryAccounting.vue'),
  },
  {
    path: '/specify-surgery-price',
    name: 'specify-surgery-price',
    component: () => import('@/views/accounting/SpecifySurgeryPrice.vue'),
  },
  {
    path: '/specify-doctor-surgery-price',
    name: 'specify-doctor-surgery-price',
    component: () => import('@/views/accounting/SpecifyDoctorSurgery.vue'),
  },

  /// //////////////////// doctor expenses ///////////////////////
  {
    path: '/doctor-expenses',
    name: 'doctor-expenses',
    component: () => import('@/views/accounting/DoctorExpenses.vue'),
  },
  {
    path: '/bed-rest-accounting',
    name: 'bed-rest-accounting',
    component: () => import('@/views/accounting/BedRestAccounting.vue'),
  },
  /// //////////////////// hospital expenses and income ///////////////////////
  {
    path: '/hospital-expenses',
    name: 'hospital-expenses',
    component: () => import('@/views/accounting/HospitalExpenses.vue'),
  },
  {
    path: '/hospital-income',
    name: 'hospital-income',
    component: () => import('@/views/accounting/HospitalIncome.vue'),
  },
  {
    path: '/hospital-exchange-rate',
    name: 'hospital-exchange-rate',
    component: () => import('@/views/accounting/HospitalExchangeRate.vue'),
  },
  {
    path: '/accounting-balance',
    name: 'accounting-balance',
    component: () => import('@/views/accounting/AccountingBalance.vue'),
  },
  // {
  //   path: "/QuickInvoice",
  //   name: "quick-invoice-accounting",
  //   component: () => import("@/views/accounting/QuickInvoice.vue"),
  // },
  {
    path: '/approved-invoices',
    name: 'approved-invoices',
    component: () => import('@/views/accounting/ApprovedInvoices.vue'),
  },
  {
    path: '/reports-surgery-operations',
    name: 'reports-surgery-operations',
    component: () => import('@/views/surgery/ReportsSurgeryOperations.vue'),
  },
  {
    path: '/report-rejected-history',
    name: 'report-rejected-history',
    component: () => import('@/views/accounting/ReportRejectedHistory.vue'),
  },
  {
    path: '/laboratory-report',
    name: 'laboratory-report',
    component: () => import('@/views/accounting/LaboratoryReport.vue'),
  },
  {
    path: '/doctors-revenue-report',
    name: 'doctors-revenue-report',
    component: () => import('@/views/accounting/DoctorsRevenueReport.vue'),
  },
  {
    path: '/casher-report',
    name: 'casher-report',
    component: () => import('@/views/accounting/CasherReport.vue'),
  },
  {
    path: '/revenue-report',
    name: 'revenue-report',
    component: () => import('@/views/accounting/RevenueReport.vue'),
  },
]
